export enum ChannelType {
    Evall = "sEVALL", // TODO: Undocumented.. Investigate
    EvallDescendants = "SEVALL", // TODO: Undocumented.. Investigate
    Event = "sEVENT", // Messages directly related to the event
    EventDescendants = "SEVENT", // Messages related to the markets and outcomes belonging to the event (but not messages related to the event itself)
    Market = "sEVMKT", // Messages directly related to the market
    MarketDescendants = "SEVMKT", // Messages related to outcomes belonging to the market (but not messages related to the market itself)
    Outcome = "sSELCN", // Messages directly related to the outcome
    Cashout = "CASH_OUT", // Special channel to get info about ticket cashout
}
